import { render, staticRenderFns } from "./kfprint.vue?vue&type=template&id=31096a0d&"
import script from "./kfprint.vue?vue&type=script&lang=js&"
export * from "./kfprint.vue?vue&type=script&lang=js&"
import style0 from "./kfprint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports